// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification--cookie[data-v-b86fbe5e] {\n  background-color: var(--magic-light, #fff);\n}\n.notification[class*=signup-error-] .icon--status[data-v-b86fbe5e] {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
